<template>
  <q-table
    v-if="sectorReports.length"
    :class="
      this.$q.dark.mode === true
        ? 'table-sticky-header-column-dark'
        : 'table-sticky-header-column'
    "
    :rows="sectorReports"
    :columns="columns"
    :pagination="pagination"
    hide-bottom
  >
    <template v-slot:body-cell-sector="props">
      <q-td :props="props">
        <q-item
          dense
          clickable
          :to="{
            name: 'SectorProfile',
            query: { symbol: getSectorSymbol(props.value) },
          }"
        >
          {{ getSectorName(props.value) }}
        </q-item>
        <q-tooltip anchor="top middle">View Trend</q-tooltip>
      </q-td>
    </template>
    <template v-slot:body-cell-SectorProfile="props">
      <q-td :props="props">
        <q-btn
          flat
          color="primary"
          label="View Trend"
          :to="{
            name: 'SectorProfile',
            query: { symbol: getSectorSymbol(props.value) },
          }"
        />
      </q-td>
    </template>
  </q-table>
</template>

<script>
import { ref } from "vue";

import useCore from "src/use/core";

export default {
  name: "SectorReportTable",

  setup() {
    const { allSector, sectorReport } = useCore();
    const allSectors = ref([]);
    const sectorReports = ref([]);

    const pagination = ref({
      rowsPerPage: 0,
    });
    const columns = ref([
      {
        name: "sector",
        required: true,
        label: "Sector",
        align: "left",
        field: "sector_id",
      },
      {
        name: "timePeriod",
        required: true,
        label: "Time Period",
        align: "right",
        format: (val, row) =>
          row.quarter.toUpperCase() + " - " + row.fiscal_year,
      },
      {
        name: "Avg Eps",
        required: true,
        label: "Avg Eps",
        align: "right",
        field: "avg_eps",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "Avg Net Worth",
        required: true,
        label: "Avg Net Worth",
        align: "right",
        field: "avg_net_worth",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "Avg Pe Ratio",
        required: true,
        label: "Avg Pe Ratio",
        align: "right",
        field: "avg_pe_ratio",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "Avg Gram Value",
        required: true,
        label: "Avg Gram Value",
        align: "right",
        field: "avg_gram_value",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "Avg Growth Rate",
        required: true,
        label: "Avg Growth Rate",
        align: "right",
        field: "avg_growth_rate",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "Avg Peg Value",
        required: true,
        label: "Avg Peg Value",
        align: "right",
        field: "avg_peg_value",
        format: (val) => parseFloat(val).toFixed(2),
      },
      {
        name: "SectorProfile",
        required: true,
        label: "Actions",
        align: "right",
        field: "sector_id",
      },
    ]);

    allSector()
      .then((res) => {
        allSectors.value = res.data;

        allSectors.value.forEach((sector) => {
          sectorReport(sector.id).then((res) => {
            sectorReports.value.push(res.data[0]);
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });

    const getSectorName = (sectorId) => {
      return allSectors.value.find((sector) => sector.id === sectorId).name;
    };

    const getSectorSymbol = (sectorId) => {
      return allSectors.value.find((sector) => sector.id === sectorId).symbol;
    };

    return {
      pagination,
      columns,

      allSectors,
      sectorReports,

      getSectorSymbol,
      getSectorName,
    };
  },
};
</script>
